import { createAction } from '@reduxjs/toolkit';

export const clearEmailForms = createAction('CLEAR_EMAIL_FORMS');
